import type { FilterFieldSpec, PboTableColumn } from '@musinsa/pbo-core'

// .handoff/gl-gl11__20260805-1601 spec.md · schema.after.json 기준 (컬럼은 스키마에서 기계 생성)

export const ORD_REMARK_OPTIONS = [{"label": "초기화", "value": "초기화"}, {"label": "중복 처리건", "value": "중복 처리건"}, {"label": "임의 합포건", "value": "임의 합포건"}, {"label": "이형", "value": "이형"}, {"label": "수량 상이", "value": "수량 상이"}, {"label": "송장 미매칭", "value": "송장 미매칭"}, {"label": "기타", "value": "기타"}]

// 편집 셀 선택지 중 서버 콤보(MOMS_COMBO_INFO)가 없는 칸 — 2.0 배선(index.tsx wiring.options)이 쓴다.
// 브랜드 컨택은 콤보가 없고 BE(GlobalInvoiceMonitoring)는 자유 문자열로 받는다. 디자인 스펙 값 그대로 고정한다.
export const BRD_CONTACT_OPTIONS = ['요청', '완료'].map((v) => ({ label: v, value: v }))
/** 센터 확인여부 — BE 는 boolean, 화면은 Y/N(queries/mapping.ts flagToCenterChecked). 1.0 콤보(true/false)는 이 변환과 맞지 않아 쓰지 않는다. */
export const CENTER_CHK_OPTIONS = ['Y', 'N'].map((v) => ({ label: v, value: v }))

export const FILTER_FIELDS: FilterFieldSpec[] = [
  {
    id: 'f-shipper',
    type: 'mfs.FormSelect',
    label: '화주명',
    required: true,
    mode: 'single',
    allOption: false,
    defaultValue: '무신사스탠다드',
    options: [],
  },
  // periodBase 미지정 — 미래 날짜도 고를 수 있다(1.0 GL11 · BE 모두 제한 없음, LOGISPRD-14480)
  // defaultPeriod 'today' — 자동 조회 없이도 픽커 폼에 오늘 범위를 표시한다.
  // chip 만으로는 표시 텍스트일 뿐 폼 값이 비어, 무날짜(전체기간) 조회가 그대로 통과했다 (E2E 결함 D-1).
  { id: 'f-clsDate', type: 'mfs.FormDatepicker', label: '최초일자', required: true, chip: '오늘', defaultPeriod: 'today' },
  { id: 'f-invoiceNo', type: 'mfs.FormTextArea', label: '송장번호', filterKey: 'INVOICE_NO' },
  { id: 'f-ordRemark', type: 'mfs.FormSelect', label: '분류', mode: 'single', allOption: true, options: ORD_REMARK_OPTIONS, filterKey: 'ORD_REMARK' },
  { id: 'f-sprOrdNo', type: 'mfs.FormTextArea', label: '주문번호', filterKey: 'SPR_ORD_NO' },
]

export const HEAD_COLUMNS: PboTableColumn[] = [
  { id: "h-rowType", title: "", width: 14, fixed: "left", variant: "groupColor", variantProps: {"groupKey": "SPR_ORD_NO"} },
  { id: "h-rowselect", title: "", width: 48, fixed: "left", variant: "rowSelect" },
  { id: "h-ordStatus", title: "MOMS 주문상태", dataIndex: "ORD_STATUS", width: 150, variant: "tag", variantProps: {"statusMap": {"가송장": {"text": "가송장", "color": "gold"}, "미출고": {"text": "미출고", "color": "red"}, "출고완료": {"text": "출고완료", "color": "green"}}} },
  { id: "h-clsDate", title: "최초일자", dataIndex: "CLS_DATE", width: 120 },
  { id: "h-refLsp1", title: "택배사", dataIndex: "REF_LSP1", width: 110 },
  { id: "h-comNm", title: "발송처", dataIndex: "COM_NM", width: 110 },
  { id: "h-invoiceNo", title: "입고송장번호", dataIndex: "INVOICE_NO", width: 160 },
  { id: "h-ordRemark", title: "분류", dataIndex: "ORD_REMARK", width: 150, variant: "select", variantProps: {"options": [{"label": "초기화", "value": "초기화"}, {"label": "중복 처리건", "value": "중복 처리건"}, {"label": "임의 합포건", "value": "임의 합포건"}, {"label": "이형", "value": "이형"}, {"label": "수량 상이", "value": "수량 상이"}, {"label": "송장 미매칭", "value": "송장 미매칭"}, {"label": "기타", "value": "기타"}]} },
  { id: "h-actQty", title: "실물수량", dataIndex: "ACT_QTY", width: 120, align: "right" },
  { id: "h-sprOrdNo", title: "주문번호", dataIndex: "SPR_ORD_NO", width: 160 },
  { id: "h-sprOrdOptNo", title: "일련번호", dataIndex: "SPR_ORD_OPT_NO", width: 170 },
  { id: "h-invoiceDiff", title: "실물송장번호", dataIndex: "INVOICE_DIFF", width: 160, variant: "input" },
  { id: "h-gdsNm", title: "상품명", dataIndex: "GDS_NM", width: 240 },
  { id: "h-gdsOpt", title: "옵션", dataIndex: "GDS_OPT", width: 100 },
  { id: "h-ordQty", title: "수량", dataIndex: "ORD_QTY", width: 90, align: "right" },
  { id: "h-brdNm", title: "브랜드", dataIndex: "BRD_NM", width: 140 },
  { id: "h-issueReason", title: "이슈 사유", dataIndex: "ISSUE_REASON", width: 140, variant: "select", variantProps: {"options": [{"label": "기타", "value": "기타"}, {"label": "송장인식 불가", "value": "송장인식 불가"}, {"label": "수량 상이", "value": "수량 상이"}, {"label": "오배송", "value": "오배송"}, {"label": "이중 출고", "value": "이중 출고"}]} },
  { id: "h-confirmDesc", title: "확인 내용", dataIndex: "CONFIRM_DESC", width: 200, variant: "input" },
  { id: "h-actionDesc", title: "대응 내용", dataIndex: "ACTION_DESC", width: 200, variant: "input" },
  { id: "h-brdContact", title: "브랜드 컨택", dataIndex: "BRD_CONTACT", width: 130, variant: "select", variantProps: {"options": [{"label": "요청", "value": "요청"}, {"label": "완료", "value": "완료"}]} },
  { id: "h-intlChkStat", title: "내부 확인상태", dataIndex: "INTL_CHK_STAT", width: 130, variant: "select", variantProps: {"options": [{"label": "확인완료", "value": "확인완료"}, {"label": "확인중", "value": "확인중"}, {"label": "확인필요", "value": "확인필요"}]} },
  { id: "h-intlChkDate", title: "내부 확인일자", dataIndex: "INTL_CHK_DATE", width: 130, variant: "datepicker" },
  { id: "h-centerChk", title: "센터 확인여부", dataIndex: "CENTER_CHK", width: 130, variant: "select", variantProps: {"options": [{"label": "Y", "value": "Y"}, {"label": "N", "value": "N"}]} },
  { id: "h-centerDesc", title: "센터 요청사항", dataIndex: "CENTER_DESC", width: 160, variant: "input" },
  { id: "h-centerLoc", title: "센터 보관위치", dataIndex: "CENTER_LOC", width: 130, variant: "input" },
  { id: "h-insDate", title: "생성일시", dataIndex: "INS_DATE", width: 160 },
  { id: "h-insBy", title: "생성자", dataIndex: "INS_BY", width: 100 },
  { id: "h-updDate", title: "수정일시", dataIndex: "UPD_DATE", width: 160 },
  { id: "h-updBy", title: "수정자", dataIndex: "UPD_BY", width: 100 },
]

export const ITEM_COLUMNS: PboTableColumn[] = [
  { id: "i-clsDate", title: "마감일자", dataIndex: "CLS_DATE", width: 120 },
  { id: "i-invoiceNo", title: "송장번호", dataIndex: "INVOICE_NO", width: 160 },
  { id: "i-ordRemark", title: "상태값", dataIndex: "ORD_REMARK", width: 110 },
  { id: "i-insDate", title: "생성일시", dataIndex: "INS_DATE", width: 160 },
  { id: "i-insBy", title: "생성자", dataIndex: "INS_BY", width: 100 },
  { id: "i-updDate", title: "수정일시", dataIndex: "UPD_DATE", width: 160 },
  { id: "i-updBy", title: "수정자", dataIndex: "UPD_BY", width: 100 },
]

/** 화면관리 그리드 설정(LOGISPRD-17254) — 표 id(생성본 columnLayout 키) → gridCd(docs/conventions/grid-code.md). 개인 컬럼 배치 저장도 같은 값을 쓴다 */
export const HEAD_TABLE_ID = 'gl11HeadTable'
export const GRID_CDS = { [HEAD_TABLE_ID]: 'GL13_HEAD', gl11ItemTable: 'GL13_ITEM' } as const

/** [저장] 이 보내는 편집 칸(queries/mapping.ts toUpdateItem) */
const SAVED_KEYS: ReadonlySet<string> = new Set(['ORD_REMARK', 'INVOICE_DIFF', 'ISSUE_REASON', 'CONFIRM_DESC', 'ACTION_DESC', 'BRD_CONTACT', 'INTL_CHK_STAT', 'INTL_CHK_DATE', 'CENTER_CHK', 'CENTER_DESC', 'CENTER_LOC'])

/**
 * [저장] 필수 검사 후보 — 화면관리 GL13_HEAD 설정이 필수로 켠 칸만 막는다(1.0 GL11 도 `CommonUtil.onSaveData` 로 막았다). 기본은 필수 아님(생성본 별표 없음).
 * dev·prd 설정은 11-05 기준 필수 0칸이다.
 */
export const SAVE_REQUIRED_CANDIDATES = HEAD_COLUMNS.filter((column) => SAVED_KEYS.has(String(column.dataIndex)))

/** 하단 이력 표(it-pager) 페이지 크기. 상단 목록은 VIEW_PAGE_SIZE 로 화면에서 나눈다. */
export const GL11_PAGE_SIZE = 500
/** 상단 목록 구간 크기 = BE size 상한 — GlobalInvoiceMonitoringController MAX_PAGE_SIZE(10000), 넘기면 400(LOGISPRD-15376). */
export const GL11_FETCH_CHUNK_SIZE = 10_000

/** GET 요청 URL 길이 임계값 — 초과 시 POST 본문으로 전환한다. */
export const GL11_URL_LENGTH_THRESHOLD = 1_500

/** 최초일자 조회 최대 허용 범위(시작·종료 포함). */
export const GL11_CLOSING_RANGE_MAX_DAYS = 31

/** UTC 날짜 범위 계산에 사용하는 하루 밀리초. */
export const GL11_MILLISECONDS_PER_DAY = 86_400_000

/** SQL IN 조건으로 전달하는 송장번호·주문번호의 필드별 최대 개수. */
export const GL11_FILTER_LIST_MAX_SIZE = 500
